import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { InterchangeTransfersState } from "@reducers/types/HRM/interchange-transfers-state";

import { getTransfersRequest } from "@actions/HRM/interchangeTransfers/transfers-actions";
import { getInterchangeTransfersState } from "@selectors/HRM/interchangeTransfers/transfers-selector";

import { useAppSelector } from "@helpers/redux";
import { InterChangeTransferType } from "@type/HRM/interchangeTransfers";
import { PaginationRequestType, PaginationType } from "@type/HRM/pagination";

interface UseInterChangeTransfers {
  transfersRequest: boolean;
  transfersSuccess: boolean;
  transfersFailed: boolean;
  transfers: InterChangeTransferType[];
  pagination: PaginationType;
  handleQuery: (key: string, value: number | boolean | string | null) => void;
}

interface StateType extends PaginationRequestType {
  status: string | null;
}

export const useInterchangeTransfers = (): UseInterChangeTransfers => {
  const [query, setQuery] = useState<StateType>({
    page: 1,
    size: 10,
    search: "",
    status: null,
  });

  const handleQuery = (key: string, value: number | boolean | string | null) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const getTransfers = useAppSelector<InterchangeTransfersState>(
    getInterchangeTransfersState,
  );

  const transfersRequest = getTransfers.request as boolean;
  const transfersSuccess = getTransfers.success as boolean;
  const transfersFailed = getTransfers.failed as boolean;
  const { data: transfers, pagination } = getTransfers.data || {};

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTransfersRequest(query));
  }, [dispatch, query]);

  return {
    transfersRequest,
    transfersSuccess,
    transfersFailed,
    transfers,
    pagination,
    handleQuery,
  };
};
